import { Spacing, Tab, Tabs as TabsIA } from 'ia-react-core';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { selectAllMessages } from '../SecuredMessagingPage.actions';
import Loader from './Loader';

export interface TabsProps {
  messagesPerPage: number;
  canWrite: boolean;
}

const Tabs: FC<TabsProps> = ({ messagesPerPage, canWrite }) => {
  const { t } = useTranslation('SecureMessagingPage');
  const dispatch = useDispatch();
  const handleTabChange = useCallback(() => {
    dispatch(selectAllMessages(false));
  }, [dispatch]);

  return (
    <TabsIA
      selectTabFromUrl
      selectTabFromUrlMethod="push"
      selectTabFromUrlParam="messageSource"
      name="messagesTabs"
      paddingXs="24px 0px 36px 0px"
      paddingSm="36px 32px 36px 32px"
      onSelect={handleTabChange}
    >
      <Tab title={t('receptionTab')} name="Inbox">
        <Spacing m-h-xs={16} m-h-sm={0}>
          <Loader messageSource="Inbox" messagesPerPage={messagesPerPage} />
        </Spacing>
      </Tab>
      {canWrite &&
        <Tab title={t('sendTab')} name="Outbox">
          <Spacing m-h-xs={16} m-h-sm={0}>
            <Loader messageSource="Outbox" messagesPerPage={messagesPerPage} />
          </Spacing>
        </Tab>}
    </TabsIA>
  );
};

export default Tabs;
